import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { translate, crudDelete, startUndoable } from 'ra-core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Checkbox } from '@material-ui/core';
import decodeJwt from 'jwt-decode';

const config = require('../../config.json');


const styles = (theme) => ({
    deleteButton: {
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }
});

class PermitsList extends Component {
    state = {
        roles: [],
        rolesPermits: {},
        token: decodeJwt(localStorage.getItem("token")).access_token,
        loading: false,
        permits: [],
        new_permits: [],
        removed_permits: [],
        role: this.props.record.role ?? "PERSONALIZADO",
        personalizado: true,
        check_role: false,
        update_data: false,
        _all_permits: [],
        actions: [
            "list", "show", "create", "edit", "delete", "export", "test", "show_prices", "create_carga", "create_retiro", "create_devolucion", "block", "validate", "change_pass"
        ],
        all_permits: {
            "users": ["create", "list", "edit", "show", "block", "delete", "export", "change_pass", "validate"],
            "buildings": ["create", "list", "edit", "show", "delete", "export"],
            "cost_centers": ["create", "list", "edit", "show", "delete", "export"],
            "internet": ["list"],
            "machine_types": ["create", "list", "edit", "show", "delete", "export"],
            "machines": ["create", "list", "edit", "show", "delete", "export"],
            "personal": ["create", "list", "edit", "show", "block", "delete", "export", "change_pass", "validate"],
            "prices": ["create", "list", "edit", "show", "delete", "export"],
            "transactions": ["list", "show", "create", "create_pago", "test", "show_prices", "create_carga", "create_retiro", "create_devolucion", "export"],
            "users_buildings": ["create", "list", "delete", "export"],
            "permits": ["list", "edit"],
            "reports": ["list"],
            "dashboard": ["list"],
            "roles": ["list", "show", "create", "edit", "delete"],
            "disconnections": ["list"],
            "messages": ["list", "show", "create", "edit", "delete"],
            "intents": ["list"]
        },
        // menos a mas importante
        // si quito uno se quitan todos los de la derecha
        // si agrego uno se agregan todos los de la izquierda
        related: {
            "users": ["list", "show", "create", "edit", "delete"],
            "buildings": ["list", "show", "create", "edit", "delete"],
            "cost_centers": ["list", "show", "create", "edit", "delete"],
            "internet": ["list"],
            "machine_types": ["list", "show", "create", "edit", "delete"],
            "machines": ["list", "show", "create", "edit", "delete"],
            "personal": ["list", "show", "create", "edit", "delete"],
            "prices": ["list", "show", "create", "edit", "delete"],
            "transactions": ["list", "show", "create", "test", "show_prices", "create_carga", "create_retiro", "create_devolucion"],
            "users_buildings": ["list", "create", "delete", "export"],
            "permits": ["list", "edit"],
            "reports": ["list"],
            "dashboard": ["list"],
            "roles": ["list", "show", "create", "edit", "delete"],
            "disconnections": ["list"],
            "messages": ["list", "show", "create", "edit", "delete"],
            "intents": ["list"]
        },
        translations: {
            "users": "Usuarios",
            "buildings": "Edificios",
            "cost_centers": "Centros de costo",
            "internet": "Internet",
            "machine_types": "Tipos de máquinas",
            "machines": "Máquinas",
            "permits": "Permisos",
            "personal": "Personal",
            "prices": "Precios",
            "transactions": "Transacciones",
            "users_buildings": "Usuarios/Edificios",
            "intents": "Intentos",
            "create": "Crear",
            "list": "Listar",
            "edit": "Editar",
            "show": "Ver",
            "delete": "Eliminar",
            "block": "Bloquear",
            "SUPER_ADMIN": "Super administrador",
            "ADMIN": "Administrador",
            "TECH": "Técnico",
            "ASEO": "Aseo",
            "FINANZAS": "Finanzas",
            "PERSONALIZADO": "Personalizado",
            "create_pago": "Crear uso de máquina",
            "create_carga": "Carga técnico",
            "create_retiro": "Retirar dinero",
            "create_devolucion": "Crear devolución",
            "test": "Probar máquina",
            "export": "Exportar",
            "validate": "Validar",
            "change_pass": "Cambio contraseña",
            "reports": "Reportes",
            "dashboard": "Dashboard",
            "roles": "Roles",
            "show_prices": "Mostrar precios",
            "USER": "Usuario",
            "disconnections": "Desconexiones",
            "messages": "Mensajes",
        }
    };

    onRoleSelect = (event) => {
        let _new_permits = [];
        let _removed_permits = [];
        this.setState({
            loading: true,
            role: event.target.value,
            personalizado: false,
        });
        let nombre;
        for (let resource in this.state.all_permits) {
            for (let action of this.state.all_permits[resource]) {
                nombre = event.target.value + "_" + resource + "." + action;
                if (this.state.rolesPermits[nombre]) {
                    _new_permits.push(resource + "." + action);
                }
            }
        }

        for (let permit of this.state.permits) {
            if (_new_permits.find(p => p === permit.resource + "." + permit.action) === undefined) {
                _removed_permits.push(permit.resource + "." + permit.action);
            }
        }

        for (let permit of this.state.permits) {
            if (_new_permits.find(p => p === permit.resource + "." + permit.action)) {
                let index2 = _new_permits.indexOf(permit.resource + "." + permit.action);
                _new_permits.splice(index2, 1);
            }
        }

        this.setState({
            _all_permits: [],
            new_permits: _new_permits,
            removed_permits: _removed_permits,
            loading: false,
            update_data: true
        });
    }

    checkRolePermits = () => {
        this.setState({ check_role: true });
    }

    checkResourceAction = (resource, action) => {
        return !this.state.removed_permits.find(permit_id => permit_id === resource + "." + action) && (this.state.permits.find(permit => permit.resource === resource && permit.action === action)
            || this.state.new_permits.find(permit_id => permit_id === resource + "." + action));
    }

    loadAllPermits = () => {
        this.setState({ update_data: false });
        let _all = {};
        for (let resource in this.state.all_permits) {
            _all[resource] = {}
            this.state.all_permits[resource].forEach(action => {

                _all[resource][action] = {
                    id: resource + "." + action,
                    resource: resource,
                    action: action,
                    check: this.checkResourceAction(resource, action)
                };
            }
            );
        }
        this.setState({
            _all_permits: _all
        });
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.loadRoles();
        this.loadPermits();
    }

    loadRoles = () => {
        return fetch(config.API_URL + "/roles?_limit=100&permit=1", {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.token
            }
        })
            .then(res => {
                return res.json();
            })
            .then(mydata => {
                let _roles = new Set();
                let _rolesPermits = {};
                mydata.forEach((row) => {
                    _roles.add(row["role"]);
                    _rolesPermits[row["role"] + "_" + row["resource"] + "." + row["action"]] = 1
                })
                this.setState({
                    roles: [..._roles],
                    rolesPermits: _rolesPermits
                });
            });
    };

    loadPermits = () => {
        const { record } = this.props;
        return fetch(config.API_URL + "/users/" + record.id + "/permits", {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                return res.json();
            })
            .then(mydata => {
                this.setState({
                    permits: mydata,
                    loading: false,
                    update_data: true
                })
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    loading: false,
                    permits: [],
                    _all_permits: {},
                    update_data: true
                })
                alert("Error al cargar los permisos");
            })
    };

    onSavePress = () => {
        const { record } = this.props;
        const { new_permits, removed_permits, role } = this.state;
        this.setState({ loading: true });
        fetch(config.API_URL + "/users/" + record.id + "/permits", {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.token
            },
            body: JSON.stringify({
                role,
                new_permits,
                removed_permits
            })
        })
            .then(res => {
                return res.json();
            })
            .then(mydata => {
                console.log("Nuevos permisos guardados", mydata);
                this.setState({
                    loading: false,
                    new_permits: [],
                    removed_permits: [],
                    permits: [],
                    update_data: false
                })
                this.loadPermits();
                if (this.props.real_role) {
                    this.callRollup();
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    loading: false,
                    new_permits: [],
                    removed_permits: [],
                    // role: "personalizado",
                    // personalizado: true,
                    _all_permits: {},
                    update_data: false
                })
                alert("Error al guardar los permisos");
            })
    };

    callRollup = () => {
        const { record } = this.props;
        fetch(config.API_URL + "/roles/" + record.id + "/rollup", {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.token
            }
        })
            .then(res => {
                return res.json();
            })
            .then(mydata => {
                console.log("Rollup", mydata);
            })
            .catch(err => {
                console.log(err);
                alert("Error al actualizar los permisos de otros usuarios");
            })
    };

    onCheckedPress = (id, checked, check_related = true) => {
        const { new_permits, removed_permits, permits } = this.state;
        
        if (!checked) {
            const index2 = removed_permits.indexOf(id);
            if (index2 !== -1) {
                removed_permits.splice(index2, 1);
            }
            const index = new_permits.indexOf(id);
            if (index === -1) {
                if (!permits.find(p => p.resource + "." + p.action === id)) {
                    new_permits.push(id);
                }
            } else {
                new_permits.splice(index, 1);
            }
        } else {
            const index = new_permits.indexOf(id);
            if (index !== -1) {
                new_permits.splice(index, 1);
            }
            const index2 = removed_permits.indexOf(id);
            if (index2 === -1) {
                if (permits.find(p => p.resource + "." + p.action === id)) {
                    removed_permits.push(id);
                }

            } else {
                removed_permits.splice(index2, 1);
            }
        }
        if (check_related) {
            this.loadRelatedPermits(id, checked);
        }
        this.setState({
            new_permits,
            removed_permits,
            check_role: false,
            update_data: true,
            // role: "PERSONALIZADO",
            // personalizado: true
        });
    };

    loadRelatedPermits = (id, removed) => {
        let data = id.split(".");
        let resource = data[0];
        let actual_action = data[1];
        let all_actions = this.state.related[resource];
        if (!all_actions.includes(actual_action)) {
            return;
        }
        if (resource === "transactions" && !["list", "show", "create", "test", "show_prices"].includes(actual_action)) {
            if (!removed) {
                if (!this.checkResourceAction("transactions", "create")) {
                    this.onCheckedPress("transactions.create", false, true);
                }
            }
            return;
        }
        let relatedActions = [];
        let add_to_list = false;
        if (removed) {
            for (let action of all_actions) {
                if (action !== actual_action) {
                    if (add_to_list) relatedActions.push(action);
                } else {
                    add_to_list = true;
                }
            }
            for (let action of relatedActions) {
                if (this.checkResourceAction(resource, action)) {
                    this.onCheckedPress(resource + "." + action, true, false);
                }
            }
        } else {
            for (let action of all_actions) {
                if (action !== actual_action) {
                    relatedActions.push(action);
                } else {
                    break;
                }
            }
            for (let action of relatedActions) {
                if (!this.checkResourceAction(resource, action)) {
                    this.onCheckedPress(resource + "." + action, false, false);
                }
            }
        }
    }

    render() {
        const { loading, new_permits, removed_permits, check_role, _all_permits, update_data, role } = this.state;
        if (loading) {
            return <CircularProgress />;
        }

        if (update_data) {
            this.loadAllPermits();
        }


        if (!check_role) {
            this.checkRolePermits();
        }

        // console.log("all", _all_permits);
        // console.log("new", new_permits);
        // console.log("rem", removed_permits);
        return (
            <div>
                {(role !== this.props.record.role || new_permits.length > 0 || removed_permits.length > 0) && <button onClick={this.onSavePress}>Guardar</button>}
                <br />
                {(this.props.real_role || (this.props.record.hasOwnProperty("blocked") && this.props.record.blocked)) ? null :
                    <select onChange={this.onRoleSelect} value={this.state.role}>
                        {this.state.roles.map((role) => {
                            return <option value={role}>{this.state.translations[role] || role}</option>
                        })}
                        <option value="PERSONALIZADO">{this.state.translations["PERSONALIZADO"]}</option>
                        <option value="USER">{this.state.translations["USER"]}</option>
                        {/* <option value="SUPER_ADMIN">{this.state.translations["SUPER_ADMIN"]}</option>
                        <option value="ADMIN">{this.state.translations["ADMIN"]}</option>
                        <option value="TECH">{this.state.translations["TECH"]}</option>
                        <option value="ASEO">{this.state.translations["ASEO"]}</option>
                        <option value="FINANZAS">{this.state.translations["FINANZAS"]}</option>
                        <option value="PERSONALIZADO">{this.state.translations["PERSONALIZADO"]}</option> */}
                    </select>}
                <br />
                {/* borders on table gray */}
                {(this.state.role === 'USER') ? <p>No hay permisos</p> :
                    <table className="table table-striped" style={{
                        borderCollapse: "collapse",
                        width: "100%"
                    }}>
                        <thead>
                            <tr>
                                <th>Recurso</th>
                                {this.state.actions.map(action => <th style={{ paddingLeft: 15, writingMode: "vertical-rl", textOrientation: "mixed", whiteSpace: "nowrap", textAlign: "right" }} key={action}>{this.state.translations[action]}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(_all_permits).map(resource => {
                                return <tr key={resource}>
                                    <td>{this.state.translations[resource]}</td>
                                    {this.state.actions.map(action => {
                                        let id = resource + "." + action;
                                        if (_all_permits[resource].hasOwnProperty(action)) {
                                            let checked = this.checkResourceAction(resource, action);
                                            return <td key={id}>
                                                <Checkbox
                                                    disabled={this.props.record.removed || !this.props.permissions_logged_user.includes("permits.edit") || (this.props.record.hasOwnProperty("blocked") && this.props.record.blocked)}
                                                    checked={checked}
                                                    onChange={() => {
                                                        this.onCheckedPress(id, checked)
                                                    }}
                                                />
                                            </td>
                                        } else {
                                            return <td key={id}>
                                                <Checkbox
                                                    disabled={true}
                                                    checked={false}
                                                />
                                            </td>
                                        }
                                    })}
                                </tr>
                            })}
                        </tbody>
                    </table>
                }
            </div>
        );

    }
}

PermitsList.propTypes = {
    basePath: PropTypes.string,
    classes: PropTypes.object,
    className: PropTypes.string,
    dispatchCrudDelete: PropTypes.func.isRequired,
    label: PropTypes.string,
    record: PropTypes.object,
    redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
    resource: PropTypes.string.isRequired,
    startUndoable: PropTypes.func,
    translate: PropTypes.func,
    undoable: PropTypes.bool,
    permissions: PropTypes.array,
};

PermitsList.defaultProps = {
    redirect: 'list',
    undoable: true
};

export default compose(
    connect(
        null,
        { startUndoable, dispatchCrudDelete: crudDelete }
    ),
    translate,
    withStyles(styles)
)(PermitsList);